/**
 * BRICK Schema Class Hierarchy
 *
 * This file contains the parent-child relationships extracted from Brick-1.4.ttl
 * Used for filtering brick_class dropdowns to show only valid subclasses
 * when a device template constrains the base class.
 *
 * Format: { parent: [direct_children] }
 */

export const BRICK_HIERARCHY = {
  'brick:Access_Control_Equipment': ['brick:Access_Reader'],
  'brick:Adjust_Sensor': ['brick:Temperature_Adjust_Sensor', 'brick:Warm_Cool_Adjust_Sensor'],
  'brick:Air_Differential_Pressure_Sensor': [
    'brick:Exhaust_Air_Differential_Pressure_Sensor',
    'brick:Filter_Air_Differential_Pressure_Sensor',
    'brick:Return_Air_Differential_Pressure_Sensor',
    'brick:Supply_Air_Differential_Pressure_Sensor',
  ],
  'brick:Air_Differential_Pressure_Setpoint': [
    'brick:Exhaust_Air_Differential_Pressure_Setpoint',
    'brick:Return_Air_Differential_Pressure_Setpoint',
    'brick:Supply_Air_Differential_Pressure_Setpoint',
  ],
  'brick:Air_Enthalpy_Sensor': ['brick:Outside_Air_Enthalpy_Sensor', 'brick:Return_Air_Enthalpy_Sensor'],
  'brick:Air_Flow_Alarm': ['brick:Air_Flow_Loss_Alarm', 'brick:High_Air_Flow_Alarm', 'brick:Low_Air_Flow_Alarm'],
  'brick:Air_Flow_Deadband_Setpoint': ['brick:Exhaust_Air_Stack_Flow_Deadband_Setpoint'],
  'brick:Air_Flow_Demand_Setpoint': ['brick:Supply_Air_Flow_Demand_Setpoint'],
  'brick:Air_Flow_Sensor': [
    'brick:Bypass_Air_Flow_Sensor',
    'brick:Exhaust_Air_Flow_Sensor',
    'brick:Fume_Hood_Air_Flow_Sensor',
    'brick:Mixed_Air_Flow_Sensor',
    'brick:Outside_Air_Flow_Sensor',
    'brick:Return_Air_Flow_Sensor',
    'brick:Supply_Air_Flow_Sensor',
  ],
  'brick:Air_Flow_Setpoint': [
    'brick:Air_Flow_Deadband_Setpoint',
    'brick:Air_Flow_Demand_Setpoint',
    'brick:Exhaust_Air_Flow_Setpoint',
    'brick:Outside_Air_Flow_Setpoint',
    'brick:Supply_Air_Flow_Setpoint',
  ],
  'brick:Air_Flow_Setpoint_Limit': ['brick:Max_Air_Flow_Setpoint_Limit', 'brick:Min_Air_Flow_Setpoint_Limit'],
  'brick:Air_Grains_Sensor': ['brick:Outside_Air_Grains_Sensor', 'brick:Return_Air_Grains_Sensor'],
  'brick:Air_Pressure_Sensor': ['brick:Air_Differential_Pressure_Sensor'],
  'brick:Air_Pressure_Setpoint': ['brick:Building_Air_Static_Pressure_Setpoint'],
  'brick:Air_Quality_Sensor': [
    'brick:Ammonia_Sensor',
    'brick:CO2_Sensor',
    'brick:CO_Sensor',
    'brick:Formaldehyde_Level_Sensor',
    'brick:Methane_Level_Sensor',
    'brick:NO2_Level_Sensor',
    'brick:Ozone_Level_Sensor',
    'brick:Particulate_Matter_Sensor',
    'brick:Radioactivity_Concentration_Sensor',
  ],
  'brick:Air_Static_Pressure_Sensor': [
    'brick:Building_Air_Static_Pressure_Sensor',
    'brick:Exhaust_Air_Static_Pressure_Sensor',
    'brick:Supply_Air_Static_Pressure_Sensor',
    'brick:Underfloor_Air_Plenum_Static_Pressure_Sensor',
  ],
  'brick:Air_Static_Pressure_Step_Parameter': ['brick:Supply_Air_Static_Pressure_Step_Parameter'],
  'brick:Air_Temperature_Alarm': ['brick:Return_Air_Temperature_Alarm', 'brick:Supply_Air_Temperature_Alarm'],
  'brick:Air_Temperature_Integral_Time_Parameter': [
    'brick:Cooling_Supply_Air_Temperature_Integral_Time_Parameter',
    'brick:Heating_Supply_Air_Temperature_Integral_Time_Parameter',
  ],
  'brick:Air_Temperature_Sensor': [
    'brick:Air_Wet_Bulb_Temperature_Sensor',
    'brick:Exhaust_Air_Temperature_Sensor',
    'brick:Mixed_Air_Temperature_Sensor',
    'brick:Outside_Air_Temperature_Sensor',
    'brick:Return_Air_Temperature_Sensor',
    'brick:Supply_Air_Temperature_Sensor',
    'brick:Underfloor_Air_Temperature_Sensor',
    'brick:Zone_Air_Temperature_Sensor',
  ],
  'brick:Air_Temperature_Setpoint': [
    'brick:Cooling_Zone_Air_Temperature_Setpoint',
    'brick:Effective_Air_Temperature_Setpoint',
    'brick:Heating_Zone_Air_Temperature_Setpoint',
    'brick:Max_Air_Temperature_Setpoint',
    'brick:Min_Air_Temperature_Setpoint',
    'brick:Mixed_Air_Temperature_Setpoint',
    'brick:Occupied_Air_Temperature_Setpoint',
    'brick:Outside_Air_Temperature_Setpoint',
    'brick:Return_Air_Temperature_Setpoint',
    'brick:Room_Air_Temperature_Setpoint',
    'brick:Supply_Air_Temperature_Deadband_Setpoint',
    'brick:Supply_Air_Temperature_Setpoint',
    'brick:Target_Zone_Air_Temperature_Setpoint',
    'brick:Unoccupied_Air_Temperature_Setpoint',
    'brick:Zone_Air_Temperature_Setpoint',
  ],
  'brick:Air_Temperature_Setpoint_Limit': ['brick:Supply_Air_Temperature_Setpoint_Limit'],
  'brick:Air_Temperature_Step_Parameter': ['brick:Supply_Air_Temperature_Step_Parameter'],
  'brick:Air_Velocity_Pressure_Sensor': [
    'brick:Exhaust_Air_Velocity_Pressure_Sensor',
    'brick:Supply_Air_Velocity_Pressure_Sensor',
  ],
  'brick:Air_Wet_Bulb_Temperature_Sensor': ['brick:Outside_Air_Wet_Bulb_Temperature_Sensor'],
  'brick:Angle_Sensor': ['brick:Solar_Azimuth_Angle_Sensor', 'brick:Solar_Zenith_Angle_Sensor'],
  'brick:Booster_Pump': [
    'brick:Chilled_Water_Booster_Pump',
    'brick:Condenser_Water_Booster_Pump',
    'brick:Hot_Water_Booster_Pump',
  ],
  'brick:Bypass_Valve': ['brick:Condenser_Water_Bypass_Valve', 'brick:Differential_Pressure_Bypass_Valve'],
  'brick:CO2_Alarm': ['brick:High_CO2_Alarm'],
  'brick:CO2_Level_Sensor': ['brick:Zone_CO2_Level_Sensor'],
  'brick:CO2_Sensor': [
    'brick:CO2_Differential_Sensor',
    'brick:CO2_Level_Sensor',
    'brick:Outside_Air_CO2_Sensor',
    'brick:Return_Air_CO2_Sensor',
  ],
  'brick:CO2_Setpoint': ['brick:Return_Air_CO2_Setpoint'],
  'brick:CO_Sensor': [
    'brick:CO_Differential_Sensor',
    'brick:CO_Level_Sensor',
    'brick:Outside_Air_CO_Sensor',
    'brick:Return_Air_CO_Sensor',
  ],
  'brick:Check_Valve': ['brick:Backflow_Preventer_Valve'],
  'brick:Chilled_Water_Differential_Pressure_Load_Shed_Status': [
    'brick:Chilled_Water_Differential_Pressure_Load_Shed_Reset_Status',
  ],
  'brick:Chilled_Water_Differential_Pressure_Setpoint': [
    'brick:Chilled_Water_Differential_Pressure_Load_Shed_Setpoint',
  ],
  'brick:Chilled_Water_Flow_Sensor': [
    'brick:Chilled_Water_Discharge_Flow_Sensor',
    'brick:Chilled_Water_Return_Flow_Sensor',
    'brick:Chilled_Water_Supply_Flow_Sensor',
    'brick:Entering_Chilled_Water_Flow_Sensor',
    'brick:Leaving_Chilled_Water_Flow_Sensor',
  ],
  'brick:Chilled_Water_Flow_Setpoint': [
    'brick:Chilled_Water_Discharge_Flow_Setpoint',
    'brick:Chilled_Water_Supply_Flow_Setpoint',
    'brick:Entering_Chilled_Water_Flow_Setpoint',
    'brick:Leaving_Chilled_Water_Flow_Setpoint',
  ],
  'brick:Chilled_Water_Pump': ['brick:Chilled_Water_Circulator_Pump'],
  'brick:Chilled_Water_Temperature_Sensor': [
    'brick:Chilled_Water_Differential_Temperature_Sensor',
    'brick:Chilled_Water_Discharge_Temperature_Sensor',
    'brick:Chilled_Water_Return_Temperature_Sensor',
    'brick:Chilled_Water_Supply_Temperature_Sensor',
    'brick:Differential_Entering_Leaving_Water_Temperature_Sensor',
    'brick:Entering_Chilled_Water_Temperature_Sensor',
    'brick:Leaving_Chilled_Water_Temperature_Sensor',
  ],
  'brick:Chilled_Water_Temperature_Setpoint': [
    'brick:Discharge_Chilled_Water_Temperature_Setpoint',
    'brick:Entering_Chilled_Water_Temperature_Setpoint',
    'brick:Leaving_Chilled_Water_Temperature_Setpoint',
    'brick:Return_Chilled_Water_Temperature_Setpoint',
    'brick:Supply_Chilled_Water_Temperature_Setpoint',
  ],
  'brick:Circulator_Pump': ['brick:Condenser_Water_Circulator_Pump', 'brick:Hot_Water_Circulator_Pump'],
  'brick:Condenser_Water_Flow_Sensor': [
    'brick:Discharge_Condenser_Water_Flow_Sensor',
    'brick:Leaving_Condenser_Water_Flow_Sensor',
    'brick:Return_Condenser_Water_Flow_Sensor',
    'brick:Supply_Condenser_Water_Flow_Sensor',
  ],
  'brick:Condenser_Water_Temperature_Sensor': [
    'brick:Discharge_Condenser_Water_Temperature_Sensor',
    'brick:Entering_Condenser_Water_Temperature_Sensor',
    'brick:Leaving_Condenser_Water_Temperature_Sensor',
    'brick:Return_Condenser_Water_Temperature_Sensor',
    'brick:Supply_Condenser_Water_Temperature_Sensor',
  ],
  'brick:Conductivity_Sensor': ['brick:Deionised_Water_Conductivity_Sensor'],
  'brick:Cooling_Demand_Sensor': ['brick:Average_Cooling_Demand_Sensor'],
  'brick:Cooling_Discharge_Air_Flow_Setpoint': [
    'brick:Occupied_Cooling_Supply_Air_Flow_Setpoint',
    'brick:Unoccupied_Cooling_Supply_Air_Flow_Setpoint',
  ],
  'brick:Cooling_Temperature_Setpoint': [
    'brick:Cooling_Supply_Air_Temperature_Deadband_Setpoint',
    'brick:Occupied_Cooling_Temperature_Deadband_Setpoint',
    'brick:Occupied_Cooling_Temperature_Setpoint',
    'brick:Supply_Air_Temperature_Cooling_Setpoint',
    'brick:Unoccupied_Cooling_Temperature_Deadband_Setpoint',
    'brick:Unoccupied_Cooling_Temperature_Setpoint',
  ],
  'brick:Cooling_Zone_Air_Temperature_Setpoint': [
    'brick:Effective_Cooling_Zone_Air_Temperature_Setpoint',
    'brick:Occupied_Cooling_Zone_Air_Temperature_Setpoint',
    'brick:Standby_Cooling_Zone_Air_Temperature_Setpoint',
    'brick:Unoccupied_Cooling_Zone_Air_Temperature_Setpoint',
  ],
  'brick:Current_Output_Sensor': ['brick:Photovoltaic_Current_Output_Sensor'],
  'brick:Current_Sensor': ['brick:Current_Output_Sensor', 'brick:Load_Current_Sensor', 'brick:Motor_Current_Sensor'],
  'brick:Damper': [
    'brick:Bypass_Damper',
    'brick:Economizer_Damper',
    'brick:Exhaust_Damper',
    'brick:Isolation_Damper',
    'brick:Mixed_Damper',
    'brick:Outside_Damper',
    'brick:Relief_Damper',
    'brick:Return_Damper',
    'brick:Zone_Damper',
  ],
  'brick:Damper_Command': ['brick:Damper_Position_Command'],
  'brick:Data_Network_Equipment': [
    'brick:Ethernet_Port',
    'brick:Ethernet_Switch',
    'brick:Network_Router',
    'brick:Network_Security_Equipment',
    'brick:Wireless_Access_Point',
  ],
  'brick:Demand_Sensor': ['brick:Cooling_Demand_Sensor', 'brick:Heating_Demand_Sensor', 'brick:Peak_Demand_Sensor'],
  'brick:Dewpoint_Sensor': [
    'brick:Exhaust_Air_Dewpoint_Sensor',
    'brick:Outside_Air_Dewpoint_Sensor',
    'brick:Return_Air_Dewpoint_Sensor',
    'brick:Supply_Air_Dewpoint_Sensor',
    'brick:Zone_Air_Dewpoint_Sensor',
  ],
  'brick:Differential_Pressure_Deadband_Setpoint': [
    'brick:Chilled_Water_Differential_Pressure_Deadband_Setpoint',
    'brick:Entering_Water_Differential_Pressure_Deadband_Setpoint',
    'brick:Hot_Water_Differential_Pressure_Deadband_Setpoint',
    'brick:Leaving_Water_Differential_Pressure_Deadband_Setpoint',
  ],
  'brick:Differential_Pressure_Integral_Time_Parameter': [
    'brick:Chilled_Water_Differential_Pressure_Integral_Time_Parameter',
    'brick:Entering_Water_Differential_Pressure_Integral_Time_Parameter',
    'brick:Hot_Water_Differential_Pressure_Integral_Time_Parameter',
    'brick:Leaving_Water_Differential_Pressure_Integral_Time_Parameter',
  ],
  'brick:Differential_Pressure_Load_Shed_Status': [
    'brick:Chilled_Water_Differential_Pressure_Load_Shed_Status',
    'brick:Hot_Water_Differential_Pressure_Load_Shed_Status',
    'brick:Medium_Temperature_Hot_Water_Differential_Pressure_Load_Shed_Status',
  ],
  'brick:Differential_Pressure_Proportional_Band': [
    'brick:Chilled_Water_Differential_Pressure_Proportional_Band_Parameter',
    'brick:Entering_Water_Differential_Pressure_Proportional_Band_Parameter',
    'brick:Hot_Water_Differential_Pressure_Proportional_Band_Parameter',
    'brick:Leaving_Water_Differential_Pressure_Proportional_Band_Parameter',
  ],
  'brick:Differential_Pressure_Sensor': [
    'brick:Filter_Differential_Pressure_Sensor',
    'brick:Water_Differential_Pressure_Sensor',
  ],
  'brick:Differential_Pressure_Setpoint': [
    'brick:Air_Differential_Pressure_Setpoint',
    'brick:Load_Shed_Differential_Pressure_Setpoint',
    'brick:Water_Differential_Pressure_Setpoint',
  ],
  'brick:Differential_Pressure_Setpoint_Limit': [
    'brick:Max_Chilled_Water_Differential_Pressure_Setpoint_Limit',
    'brick:Max_Hot_Water_Differential_Pressure_Setpoint_Limit',
    'brick:Min_Chilled_Water_Differential_Pressure_Setpoint_Limit',
    'brick:Min_Hot_Water_Differential_Pressure_Setpoint_Limit',
  ],
  'brick:Differential_Pressure_Step_Parameter': ['brick:Chilled_Water_Differential_Pressure_Step_Parameter'],
  'brick:Differential_Temperature_Setpoint': [
    'brick:Differential_Air_Temperature_Setpoint',
    'brick:Water_Differential_Temperature_Setpoint',
  ],
  'brick:Direction_Sensor': ['brick:Wind_Direction_Sensor'],
  'brick:Discharge_Air_Static_Pressure_Setpoint': ['brick:Supply_Air_Static_Pressure_Deadband_Setpoint'],
  'brick:Discharge_Air_Temperature_Heating_Setpoint': ['brick:Heating_Supply_Air_Temperature_Deadband_Setpoint'],
  'brick:Discharge_Hot_Water_Temperature_Setpoint': ['brick:Domestic_Hot_Water_Discharge_Temperature_Setpoint'],
  'brick:Discharge_Water_Flow_Sensor': ['brick:Hot_Water_Discharge_Flow_Sensor'],
  'brick:Discharge_Water_Flow_Setpoint': ['brick:Hot_Water_Discharge_Flow_Setpoint'],
  'brick:Discharge_Water_Temperature_Sensor': [
    'brick:Discharge_Condenser_Water_Temperature_Setpoint',
    'brick:Discharge_Hot_Water_Temperature_Setpoint',
    'brick:Hot_Water_Discharge_Temperature_Sensor',
  ],
  'brick:Domestic_Hot_Water_Temperature_Sensor': [
    'brick:Domestic_Hot_Water_Discharge_Temperature_Sensor',
    'brick:Entering_Domestic_Hot_Water_Temperature_Sensor',
    'brick:Leaving_Domestic_Hot_Water_Temperature_Sensor',
  ],
  'brick:Domestic_Hot_Water_Temperature_Setpoint': [
    'brick:Entering_Domestic_Hot_Water_Temperature_Setpoint',
    'brick:Leaving_Domestic_Hot_Water_Temperature_Setpoint',
  ],
  'brick:Duration_Sensor': ['brick:On_Timer_Sensor', 'brick:Rain_Duration_Sensor'],
  'brick:Effective_Air_Temperature_Setpoint': [
    'brick:Effective_Air_Temperature_Cooling_Setpoint',
    'brick:Effective_Air_Temperature_Heating_Setpoint',
    'brick:Effective_Heating_Zone_Air_Temperature_Setpoint',
    'brick:Effective_Return_Air_Temperature_Setpoint',
    'brick:Effective_Room_Air_Temperature_Setpoint',
    'brick:Effective_Supply_Air_Temperature_Setpoint',
    'brick:Effective_Target_Zone_Air_Temperature_Setpoint',
  ],
  'brick:Electric_Energy_Sensor': ['brick:Reactive_Energy_Sensor'],
  'brick:Electric_Power_Sensor': ['brick:Active_Power_Sensor', 'brick:Reactive_Power_Sensor'],
  'brick:Electrical_Equipment': [
    'brick:Breaker_Panel',
    'brick:Bus_Riser',
    'brick:Electric_Vehicle_Charging_Port',
    'brick:Electric_Vehicle_Charging_Station',
    'brick:Energy_Storage',
    'brick:Inverter',
    'brick:Motor_Control_Center',
    'brick:PlugStrip',
    'brick:Switchgear',
    'brick:Transformer',
  ],
  'brick:Embedded_Temperature_Sensor': ['brick:Core_Temperature_Sensor'],
  'brick:Embedded_Temperature_Setpoint': ['brick:Core_Temperature_Setpoint'],
  'brick:Energy_Sensor': ['brick:Electric_Energy_Sensor', 'brick:Energy_Usage_Sensor'],
  'brick:Energy_Usage_Sensor': ['brick:Electrical_Energy_Usage_Sensor', 'brick:Thermal_Energy_Usage_Sensor'],
  'brick:Entering_Hot_Water_Temperature_High_Reset_Setpoint': [
    'brick:Entering_Medium_Temperature_Hot_Water_Temperature_High_Reset_Setpoint',
  ],
  'brick:Entering_Hot_Water_Temperature_Load_Shed_Status': [
    'brick:Entering_Medium_Temperature_Hot_Water_Temperature_Load_Shed_Status',
  ],
  'brick:Entering_Hot_Water_Temperature_Low_Reset_Setpoint': [
    'brick:Entering_Medium_Temperature_Hot_Water_Temperature_Low_Reset_Setpoint',
  ],
  'brick:Entering_Hot_Water_Temperature_Sensor': [
    'brick:Entering_High_Temperature_Hot_Water_Temperature_Sensor',
    'brick:Entering_Medium_Temperature_Hot_Water_Temperature_Sensor',
  ],
  'brick:Entering_Water_Flow_Sensor': [
    'brick:Entering_Condenser_Water_Flow_Sensor',
    'brick:Entering_Hot_Water_Flow_Sensor',
  ],
  'brick:Entering_Water_Flow_Setpoint': ['brick:Entering_Hot_Water_Flow_Setpoint'],
  'brick:Entering_Water_Temperature_Setpoint': [
    'brick:Entering_Hot_Water_Temperature_Setpoint',
    'brick:Entering_Water_Temperature_Deadband_Setpoint',
  ],
  'brick:Enthalpy_Sensor': ['brick:Air_Enthalpy_Sensor'],
  'brick:Equipment': [
    'brick:Camera',
    'brick:Electrical_Equipment',
    'brick:Elevator',
    'brick:Fire_Safety_Equipment',
    'brick:Furniture',
    'brick:Gas_Distribution',
    'brick:HVAC_Equipment',
    'brick:ICT_Equipment',
    'brick:Lighting_Equipment',
    'brick:Meter',
    'brick:Motor',
    'brick:PV_Panel',
    'brick:Relay',
    'brick:Safety_Equipment',
    'brick:Security_Equipment',
    'brick:Shading_Equipment',
    'brick:Solar_Thermal_Collector',
    'brick:Steam_Distribution',
    'brick:Tank',
    'brick:Valve',
    'brick:Water_Distribution',
    'brick:Water_Heater',
    'brick:Weather_Station',
  ],
  'brick:Exhaust_Air_Flow_Integral_Time_Parameter': ['brick:Exhaust_Air_Stack_Flow_Integral_Time_Parameter'],
  'brick:Exhaust_Air_Flow_Proportional_Band_Parameter': ['brick:Exhaust_Air_Stack_Flow_Proportional_Band_Parameter'],
  'brick:Exhaust_Air_Flow_Sensor': ['brick:Exhaust_Air_Stack_Flow_Sensor'],
  'brick:Exhaust_Air_Flow_Setpoint': ['brick:Exhaust_Air_Stack_Flow_Setpoint'],
  'brick:Exhaust_Air_Static_Pressure_Sensor': [
    'brick:Average_Exhaust_Air_Static_Pressure_Sensor',
    'brick:Lowest_Exhaust_Air_Static_Pressure_Sensor',
  ],
  'brick:Fan': [
    'brick:Booster_Fan',
    'brick:Ceiling_Fan',
    'brick:Cooling_Tower_Fan',
    'brick:Exhaust_Fan',
    'brick:Fresh_Air_Fan',
    'brick:Outside_Fan',
    'brick:Pressurization_Fan',
    'brick:Relief_Fan',
    'brick:Return_Fan',
    'brick:Standby_Fan',
    'brick:Supply_Fan',
    'brick:Transfer_Fan',
  ],
  'brick:Fan_Coil_Unit': [
    'brick:Cassette_Fan_Coil_Unit',
    'brick:Duct_Fan_Coil_Unit',
    'brick:Floor_Fan_Coil_Unit',
    'brick:Wall_Fan_Coil_Unit',
  ],
  'brick:Fan_Command': ['brick:Fan_Speed_Command'],
  'brick:Fan_Status': ['brick:Fan_On_Off_Status'],
  'brick:Filter_Differential_Pressure_Sensor': ['brick:Filter_Water_Differential_Pressure_Sensor'],
  'brick:Fire_Safety_Equipment': [
    'brick:Fire_Alarm',
    'brick:Fire_Alarm_Control_Panel',
    'brick:Fire_Control_Panel',
    'brick:Heat_Detector',
    'brick:Manual_Fire_Alarm_Activation_Equipment',
    'brick:Smoke_Detector',
  ],
  'brick:Flow_Sensor': ['brick:Air_Flow_Sensor', 'brick:Natural_Gas_Flow_Sensor', 'brick:Water_Flow_Sensor'],
  'brick:Flow_Setpoint': ['brick:Air_Flow_Setpoint', 'brick:Water_Flow_Setpoint'],
  'brick:Frequency_Sensor': ['brick:Output_Frequency_Sensor'],
  'brick:Gas_Valve': ['brick:Gas_Pressure_Regulator_Valve'],
  'brick:Gauge_Pressure_Sensor': ['brick:Chilled_Water_Gauge_Pressure_Sensor', 'brick:Hot_Water_Gauge_Pressure_Sensor'],
  'brick:Generation_Sensor': ['brick:Energy_Generation_Sensor'],
  'brick:HVAC_Equipment': [
    'brick:Air_Handling_Unit',
    'brick:Air_Plenum',
    'brick:Boiler',
    'brick:Branch_Selector',
    'brick:Bypass_Valve',
    'brick:Chiller',
    'brick:Cold_Deck',
    'brick:Compressor',
    'brick:Computer_Room_Air_Conditioning',
    'brick:Computer_Room_Air_Handler',
    'brick:Condensing_Unit',
    'brick:Cooling_Tower',
    'brick:Cooling_Valve',
    'brick:Damper',
    'brick:Dry_Cooler',
    'brick:Economizer',
    'brick:Fan',
    'brick:Filter',
    'brick:Fume_Hood',
    'brick:HVAC_Valve',
    'brick:Heat_Exchanger',
    'brick:Heating_Valve',
    'brick:Hot_Deck',
    'brick:Humidifier',
    'brick:Isolation_Valve',
    'brick:Packaged_Heat_Pump',
    'brick:Pump',
    'brick:Refrigerant_Metering_Device',
    'brick:Space_Heater',
    'brick:Steam_Valve',
    'brick:Terminal_Unit',
    'brick:Thermostat',
    'brick:Wall_Air_Conditioner',
  ],
  'brick:HVAC_Valve': ['brick:Chilled_Water_Valve', 'brick:Condenser_Water_Valve', 'brick:Makeup_Water_Valve'],
  'brick:Heat_Pump_Condensing_Unit': [
    'brick:Heat_Pump_Air_Source_Condensing_Unit',
    'brick:Heat_Pump_Ground_Source_Condensing_Unit',
    'brick:Heat_Pump_Water_Source_Condensing_Unit',
  ],
  'brick:Heating_Demand_Sensor': ['brick:Average_Heating_Demand_Sensor'],
  'brick:Heating_Discharge_Air_Flow_Setpoint': [
    'brick:Occupied_Heating_Supply_Air_Flow_Setpoint',
    'brick:Unoccupied_Heating_Supply_Air_Flow_Setpoint',
  ],
  'brick:Heating_Temperature_Setpoint': [
    'brick:Occupied_Heating_Temperature_Deadband_Setpoint',
    'brick:Occupied_Heating_Temperature_Setpoint',
    'brick:Open_Heating_Valve_Outside_Air_Temperature_Setpoint',
    'brick:Supply_Air_Temperature_Heating_Setpoint',
    'brick:Unoccupied_Heating_Temperature_Deadband_Setpoint',
    'brick:Unoccupied_Heating_Temperature_Setpoint',
  ],
  'brick:Heating_Valve': ['brick:Hot_Water_Valve', 'brick:Reheat_Valve', 'brick:Return_Heating_Valve'],
  'brick:Heating_Zone_Air_Temperature_Setpoint': [
    'brick:Occupied_Heating_Zone_Air_Temperature_Setpoint',
    'brick:Standby_Heating_Zone_Air_Temperature_Setpoint',
    'brick:Unoccupied_Heating_Zone_Air_Temperature_Setpoint',
  ],
  'brick:High_Temperature_Alarm': [
    'brick:High_Return_Air_Temperature_Alarm',
    'brick:High_Supply_Air_Temperature_Alarm',
  ],
  'brick:Hot_Water_Circulator_Pump': ['brick:Domestic_Hot_Water_Circulator_Pump'],
  'brick:Hot_Water_Differential_Pressure_Load_Shed_Status': [
    'brick:Hot_Water_Differential_Pressure_Load_Shed_Reset_Status',
  ],
  'brick:Hot_Water_Differential_Pressure_Sensor': [
    'brick:Domestic_Hot_Water_Differential_Pressure_Sensor',
    'brick:Medium_Temperature_Hot_Water_Differential_Pressure_Sensor',
  ],
  'brick:Hot_Water_Differential_Pressure_Setpoint': [
    'brick:Domestic_Hot_Water_Differential_Pressure_Setpoint',
    'brick:Medium_Temperature_Hot_Water_Differential_Pressure_Setpoint',
  ],
  'brick:Hot_Water_Discharge_Temperature_Sensor': [
    'brick:High_Temperature_Hot_Water_Discharge_Temperature_Sensor',
    'brick:Medium_Temperature_Hot_Water_Discharge_Temperature_Sensor',
  ],
  'brick:Hot_Water_Flow_Sensor': [
    'brick:Hot_Water_Return_Flow_Sensor',
    'brick:Hot_Water_Supply_Flow_Sensor',
    'brick:Leaving_Hot_Water_Flow_Sensor',
  ],
  'brick:Hot_Water_Flow_Setpoint': ['brick:Leaving_Hot_Water_Flow_Setpoint'],
  'brick:Hot_Water_Return_Temperature_Sensor': [
    'brick:High_Temperature_Hot_Water_Return_Temperature_Sensor',
    'brick:Medium_Temperature_Hot_Water_Return_Temperature_Sensor',
  ],
  'brick:Hot_Water_Supply_Temperature_Sensor': [
    'brick:Domestic_Hot_Water_Supply_Temperature_Sensor',
    'brick:High_Temperature_Hot_Water_Supply_Temperature_Sensor',
    'brick:Medium_Temperature_Hot_Water_Supply_Temperature_Sensor',
  ],
  'brick:Hot_Water_Temperature_Setpoint': [
    'brick:Domestic_Hot_Water_Temperature_Setpoint',
    'brick:Leaving_Hot_Water_Temperature_Setpoint',
  ],
  'brick:Hot_Water_Valve': ['brick:Domestic_Hot_Water_Valve', 'brick:Preheat_Hot_Water_Valve'],
  'brick:Humidity_Alarm': ['brick:High_Humidity_Alarm', 'brick:Low_Humidity_Alarm'],
  'brick:Humidity_Parameter': [
    'brick:High_Humidity_Alarm_Parameter',
    'brick:Humidity_Tolerance_Parameter',
    'brick:Low_Humidity_Alarm_Parameter',
  ],
  'brick:Humidity_Sensor': ['brick:Absolute_Humidity_Sensor', 'brick:Relative_Humidity_Sensor'],
  'brick:Humidity_Setpoint': [
    'brick:Building_Air_Humidity_Setpoint',
    'brick:Bypass_Air_Humidity_Setpoint',
    'brick:Exhaust_Air_Humidity_Setpoint',
    'brick:Mixed_Air_Humidity_Setpoint',
    'brick:Occupied_Humidity_Setpoint',
    'brick:Outside_Air_Humidity_Setpoint',
    'brick:Return_Air_Humidity_Setpoint',
    'brick:Supply_Air_Humidity_Setpoint',
    'brick:Unoccupied_Humidity_Setpoint',
    'brick:Zone_Air_Humidity_Setpoint',
  ],
  'brick:ICT_Equipment': [
    'brick:Audio_Visual_Equipment',
    'brick:Controller',
    'brick:Data_Network_Equipment',
    'brick:Gateway',
    'brick:ICT_Hardware',
    'brick:ICT_Rack',
    'brick:Sensor_Equipment',
  ],
  'brick:Illuminance_Sensor': ['brick:Outside_Illuminance_Sensor'],
  'brick:Imbalance_Sensor': ['brick:Current_Imbalance_Sensor', 'brick:Voltage_Imbalance_Sensor'],
  'brick:Intercom_Equipment': ['brick:Emergency_Phone', 'brick:Video_Intercom'],
  'brick:Isolation_Valve': ['brick:Condenser_Water_Isolation_Valve'],
  'brick:Leaving_Hot_Water_Temperature_High_Reset_Setpoint': [
    'brick:Leaving_Medium_Temperature_Hot_Water_Temperature_High_Reset_Setpoint',
  ],
  'brick:Leaving_Hot_Water_Temperature_Load_Shed_Status': [
    'brick:Leaving_Medium_Temperature_Hot_Water_Temperature_Load_Shed_Status',
  ],
  'brick:Leaving_Hot_Water_Temperature_Low_Reset_Setpoint': [
    'brick:Leaving_Medium_Temperature_Hot_Water_Temperature_Low_Reset_Setpoint',
  ],
  'brick:Leaving_Hot_Water_Temperature_Sensor': [
    'brick:Leaving_High_Temperature_Hot_Water_Temperature_Sensor',
    'brick:Leaving_Medium_Temperature_Hot_Water_Temperature_Sensor',
  ],
  'brick:Leaving_Water_Temperature_Sensor': [
    'brick:Heat_Exchanger_Leaving_Water_Temperature_Sensor',
    'brick:Ice_Tank_Leaving_Water_Temperature_Sensor',
  ],
  'brick:Leaving_Water_Temperature_Setpoint': [
    'brick:Entering_Condenser_Water_Temperature_Setpoint',
    'brick:Leaving_Condenser_Water_Temperature_Setpoint',
    'brick:Leaving_Water_Temperature_Deadband_Setpoint',
  ],
  'brick:Lighting_Equipment': ['brick:Interface', 'brick:Lighting'],
  'brick:Lockout_Temperature_Differential_Parameter': ['brick:Outside_Air_Lockout_Temperature_Differential_Parameter'],
  'brick:Low_Air_Flow_Alarm': ['brick:Low_Supply_Air_Flow_Alarm'],
  'brick:Low_Temperature_Alarm': ['brick:Low_Return_Air_Temperature_Alarm', 'brick:Low_Supply_Air_Temperature_Alarm'],
  'brick:Manual_Fire_Alarm_Activation_Equipment': [
    'brick:Fire_Alarm_Manual_Call_Point',
    'brick:Fire_Alarm_Pull_Station',
  ],
  'brick:Max_Air_Flow_Setpoint_Limit': [
    'brick:Max_Cooling_Supply_Air_Flow_Setpoint_Limit',
    'brick:Max_Heating_Supply_Air_Flow_Setpoint_Limit',
    'brick:Max_Outside_Air_Flow_Setpoint_Limit',
  ],
  'brick:Max_Cooling_Supply_Air_Flow_Setpoint_Limit': [
    'brick:Max_Occupied_Cooling_Supply_Air_Flow_Setpoint_Limit',
    'brick:Max_Unoccupied_Cooling_Supply_Air_Flow_Setpoint_Limit',
  ],
  'brick:Max_Heating_Supply_Air_Flow_Setpoint_Limit': [
    'brick:Max_Occupied_Heating_Supply_Air_Flow_Setpoint_Limit',
    'brick:Max_Unoccupied_Heating_Supply_Air_Flow_Setpoint_Limit',
  ],
  'brick:Max_Temperature_Setpoint_Limit': ['brick:Max_Supply_Air_Temperature_Setpoint_Limit'],
  'brick:Medium_Temperature_Hot_Water_Differential_Pressure_Load_Shed_Status': [
    'brick:Medium_Temperature_Hot_Water_Differential_Pressure_Load_Shed_Reset_Status',
  ],
  'brick:Min_Air_Flow_Setpoint_Limit': [
    'brick:Min_Cooling_Supply_Air_Flow_Setpoint_Limit',
    'brick:Min_Heating_Supply_Air_Flow_Setpoint_Limit',
    'brick:Min_Outside_Air_Flow_Setpoint_Limit',
  ],
  'brick:Min_Cooling_Supply_Air_Flow_Setpoint_Limit': [
    'brick:Min_Occupied_Cooling_Supply_Air_Flow_Setpoint_Limit',
    'brick:Min_Unoccupied_Cooling_Supply_Air_Flow_Setpoint_Limit',
  ],
  'brick:Min_Heating_Supply_Air_Flow_Setpoint_Limit': [
    'brick:Min_Occupied_Heating_Supply_Air_Flow_Setpoint_Limit',
    'brick:Min_Unoccupied_Heating_Supply_Air_Flow_Setpoint_Limit',
  ],
  'brick:Min_Temperature_Setpoint_Limit': ['brick:Min_Supply_Air_Temperature_Setpoint_Limit'],
  'brick:Mixing_Valve': ['brick:Electronic_Mixing_Valve', 'brick:Thermostatic_Mixing_Valve'],
  'brick:Motion_Sensor': ['brick:PIR_Sensor'],
  'brick:Occupied_Air_Temperature_Setpoint': [
    'brick:Occupied_Air_Temperature_Cooling_Setpoint',
    'brick:Occupied_Air_Temperature_Heating_Setpoint',
    'brick:Occupied_Return_Air_Temperature_Setpoint',
    'brick:Occupied_Room_Air_Temperature_Setpoint',
    'brick:Occupied_Supply_Air_Temperature_Setpoint',
    'brick:Occupied_Target_Zone_Air_Temperature_Setpoint',
  ],
  'brick:Outside_Air_Lockout_Temperature_Differential_Parameter': [
    'brick:High_Outside_Air_Lockout_Temperature_Differential_Parameter',
    'brick:Low_Outside_Air_Lockout_Temperature_Differential_Parameter',
  ],
  'brick:Outside_Air_Temperature_Enable_Differential_Sensor': [
    'brick:Low_Outside_Air_Temperature_Enable_Differential_Sensor',
  ],
  'brick:Outside_Air_Temperature_Sensor': [
    'brick:Intake_Air_Temperature_Sensor',
    'brick:Outside_Air_Temperature_Enable_Differential_Sensor',
  ],
  'brick:Outside_Air_Temperature_Setpoint': [
    'brick:Disable_Hot_Water_System_Outside_Air_Temperature_Setpoint',
    'brick:Enable_Hot_Water_System_Outside_Air_Temperature_Setpoint',
    'brick:Low_Outside_Air_Temperature_Enable_Setpoint',
    'brick:Outside_Air_Lockout_Temperature_Setpoint',
  ],
  'brick:PM10_Sensor': ['brick:PM10_Level_Sensor'],
  'brick:PM1_Sensor': ['brick:PM1_Level_Sensor'],
  'brick:Packaged_Heat_Pump': ['brick:Packaged_Air_Source_Heat_Pump', 'brick:Packaged_Water_Source_Heat_Pump'],
  'brick:Particulate_Matter_Sensor': ['brick:PM10_Sensor', 'brick:PM1_Sensor', 'brick:TVOC_Sensor'],
  'brick:Position_Sensor': [
    'brick:Damper_Position_Sensor',
    'brick:Sash_Position_Sensor',
    'brick:Valve_Position_Sensor',
  ],
  'brick:Power_Sensor': ['brick:Electric_Power_Sensor', 'brick:Thermal_Power_Sensor'],
  'brick:Pressure_Alarm': ['brick:High_Head_Pressure_Alarm', 'brick:Low_Suction_Pressure_Alarm'],
  'brick:Pressure_Reducing_Valve': ['brick:Steam_Pressure_Reducing_Valve', 'brick:Water_Pressure_Reducing_Valve'],
  'brick:Pressure_Relief_Valve': ['brick:Steam_Pressure_Relief_Valve', 'brick:Water_Pressure_Relief_Valve'],
  'brick:Pressure_Sensor': [
    'brick:Air_Pressure_Sensor',
    'brick:Differential_Pressure_Sensor',
    'brick:Gauge_Pressure_Sensor',
    'brick:Static_Pressure_Sensor',
    'brick:Velocity_Pressure_Sensor',
    'brick:Water_Pressure_Sensor',
  ],
  'brick:Pressure_Setpoint': [
    'brick:Air_Pressure_Setpoint',
    'brick:Static_Pressure_Setpoint',
    'brick:Velocity_Pressure_Setpoint',
    'brick:Water_Pressure_Setpoint',
  ],
  'brick:Pressure_Status': ['brick:Supply_Air_Duct_Pressure_Status'],
  'brick:Pump': ['brick:Booster_Pump', 'brick:Circulator_Pump', 'brick:Water_Pump'],
  'brick:Radiant_Panel_Temperature_Sensor': [
    'brick:Embedded_Temperature_Sensor',
    'brick:Inside_Face_Surface_Temperature_Sensor',
    'brick:Outside_Face_Surface_Temperature_Sensor',
  ],
  'brick:Radiant_Panel_Temperature_Setpoint': [
    'brick:Embedded_Temperature_Setpoint',
    'brick:Inside_Face_Surface_Temperature_Setpoint',
    'brick:Outside_Face_Surface_Temperature_Setpoint',
  ],
  'brick:Radioactivity_Concentration_Sensor': ['brick:Radon_Concentration_Sensor'],
  'brick:Refrigerant_Valve': ['brick:Reversing_Valve'],
  'brick:Relative_Humidity_Sensor': [
    'brick:Exhaust_Air_Humidity_Sensor',
    'brick:Mixed_Air_Humidity_Sensor',
    'brick:Outside_Air_Humidity_Sensor',
    'brick:Return_Air_Humidity_Sensor',
    'brick:Supply_Air_Humidity_Sensor',
    'brick:Zone_Air_Humidity_Sensor',
  ],
  'brick:Return_Air_Temperature_Setpoint': ['brick:Unoccupied_Return_Air_Temperature_Setpoint'],
  'brick:Return_Water_Temperature_Sensor': ['brick:Hot_Water_Return_Temperature_Sensor'],
  'brick:Return_Water_Temperature_Setpoint': [
    'brick:Return_Condenser_Water_Temperature_Setpoint',
    'brick:Return_Hot_Water_Temperature_Setpoint',
  ],
  'brick:Room_Air_Temperature_Setpoint': ['brick:Unoccupied_Room_Air_Temperature_Setpoint'],
  'brick:Safety_Equipment': [
    'brick:Automated_External_Defibrillator',
    'brick:Emergency_Wash_Station',
    'brick:First_Aid_Kit',
  ],
  'brick:Security_Equipment': [
    'brick:Access_Control_Equipment',
    'brick:Intercom_Equipment',
    'brick:Intrusion_Detection_Equipment',
    'brick:Video_Surveillance_Equipment',
  ],
  'brick:Sensor': [
    'brick:Adjust_Sensor',
    'brick:Air_Grains_Sensor',
    'brick:Air_Quality_Sensor',
    'brick:Angle_Sensor',
    'brick:Capacity_Sensor',
    'brick:Conductivity_Sensor',
    'brick:Contact_Sensor',
    'brick:Current_Sensor',
    'brick:Demand_Sensor',
    'brick:Dewpoint_Sensor',
    'brick:Direction_Sensor',
    'brick:Duration_Sensor',
    'brick:Energy_Sensor',
    'brick:Enthalpy_Sensor',
    'brick:Fire_Sensor',
    'brick:Flow_Sensor',
    'brick:Frequency_Sensor',
    'brick:Frost_Sensor',
    'brick:Gas_Sensor',
    'brick:Generation_Sensor',
    'brick:Hail_Sensor',
    'brick:Humidity_Sensor',
    'brick:Illuminance_Sensor',
    'brick:Imbalance_Sensor',
    'brick:Lighting_Correlated_Color_Temperature_Sensor',
    'brick:Luminance_Sensor',
    'brick:Motion_Sensor',
    'brick:Occupancy_Count_Sensor',
    'brick:Occupancy_Sensor',
    'brick:Piezoelectric_Sensor',
    'brick:Position_Sensor',
    'brick:Power_Factor_Sensor',
    'brick:Power_Sensor',
    'brick:Pressure_Sensor',
    'brick:Rain_Level_Sensor',
    'brick:Refrigerant_Level_Sensor',
    'brick:Solar_Irradiance_Sensor',
    'brick:Solar_Radiance_Sensor',
    'brick:Speed_Sensor',
    'brick:Temperature_Sensor',
    'brick:Torque_Sensor',
    'brick:Usage_Sensor',
    'brick:Voltage_Sensor',
    'brick:Waste_Amount_Sensor',
    'brick:Water_Level_Sensor',
  ],
  'brick:Sensor_Equipment': [
    'brick:Daylight_Sensor_Equipment',
    'brick:IAQ_Sensor_Equipment',
    'brick:Leak_Detector_Equipment',
    'brick:Occupancy_Sensor_Equipment',
    'brick:People_Count_Sensor_Equipment',
    'brick:Thermostat_Equipment',
    'brick:Vibration_Sensor_Equipment',
  ],
  'brick:Shading_Equipment': ['brick:Automatic_Tint_Window', 'brick:Blind'],
  'brick:Speed_Sensor': ['brick:Differential_Speed_Sensor', 'brick:Motor_Speed_Sensor', 'brick:Wind_Speed_Sensor'],
  'brick:Static_Pressure_Integral_Time_Parameter': ['brick:Supply_Air_Static_Pressure_Integral_Time_Parameter'],
  'brick:Static_Pressure_Proportional_Band_Parameter': [
    'brick:Exhaust_Air_Static_Pressure_Proportional_Band_Parameter',
    'brick:Supply_Air_Static_Pressure_Proportional_Band_Parameter',
  ],
  'brick:Static_Pressure_Sensor': ['brick:Air_Static_Pressure_Sensor'],
  'brick:Static_Pressure_Setpoint': [
    'brick:Chilled_Water_Static_Pressure_Setpoint',
    'brick:Duct_Air_Static_Pressure_Setpoint',
    'brick:Exhaust_Air_Static_Pressure_Setpoint',
    'brick:Hot_Water_Static_Pressure_Setpoint',
    'brick:Supply_Air_Static_Pressure_Setpoint',
    'brick:Underfloor_Air_Plenum_Static_Pressure_Setpoint',
  ],
  'brick:Static_Pressure_Setpoint_Limit': ['brick:High_Static_Pressure_Cutout_Setpoint_Limit'],
  'brick:Static_Pressure_Step_Parameter': ['brick:Air_Static_Pressure_Step_Parameter'],
  'brick:Supply_Air_Flow_Reset_Setpoint': [
    'brick:Supply_Air_Flow_High_Reset_Setpoint',
    'brick:Supply_Air_Flow_Low_Reset_Setpoint',
  ],
  'brick:Supply_Air_Flow_Sensor': ['brick:Average_Supply_Air_Flow_Sensor'],
  'brick:Supply_Air_Flow_Setpoint': [
    'brick:Cooling_Supply_Air_Flow_Setpoint',
    'brick:Heating_Supply_Air_Flow_Setpoint',
    'brick:Occupied_Supply_Air_Flow_Setpoint',
    'brick:Unoccupied_Supply_Air_Flow_Setpoint',
  ],
  'brick:Supply_Air_Temperature_Proportional_Band_Parameter': [
    'brick:Cooling_Supply_Air_Temperature_Proportional_Band_Parameter',
    'brick:Heating_Supply_Air_Temperature_Proportional_Band_Parameter',
  ],
  'brick:Supply_Air_Temperature_Reset_Differential_Setpoint': [
    'brick:Supply_Air_Temperature_High_Reset_Setpoint',
    'brick:Supply_Air_Temperature_Low_Reset_Setpoint',
  ],
  'brick:Supply_Air_Temperature_Sensor': ['brick:Preheat_Supply_Air_Temperature_Sensor'],
  'brick:Supply_Air_Temperature_Setpoint': ['brick:Unoccupied_Supply_Air_Temperature_Setpoint'],
  'brick:Supply_Hot_Water_Temperature_Setpoint': ['brick:Domestic_Hot_Water_Supply_Temperature_Setpoint'],
  'brick:Supply_Water_Temperature_Sensor': [
    'brick:Hot_Water_Supply_Flow_Setpoint',
    'brick:Hot_Water_Supply_Temperature_Sensor',
    'brick:Supply_Condenser_Water_Temperature_Setpoint',
    'brick:Supply_Hot_Water_Temperature_Setpoint',
  ],
  'brick:TVOC_Sensor': ['brick:TVOC_Level_Sensor'],
  'brick:Target_Zone_Air_Temperature_Setpoint': [
    'brick:Standby_Target_Zone_Air_Temperature_Setpoint',
    'brick:Unoccupied_Target_Zone_Air_Temperature_Setpoint',
  ],
  'brick:Temperature_Alarm': [
    'brick:High_Temperature_Alarm',
    'brick:Low_Temperature_Alarm',
    'brick:Water_Temperature_Alarm',
  ],
  'brick:Temperature_Differential_Reset_Setpoint': ['brick:Supply_Air_Temperature_Reset_Differential_Setpoint'],
  'brick:Temperature_High_Reset_Setpoint': [
    'brick:Entering_Hot_Water_Temperature_High_Reset_Setpoint',
    'brick:Leaving_Hot_Water_Temperature_High_Reset_Setpoint',
    'brick:Outside_Air_Temperature_High_Reset_Setpoint',
    'brick:Return_Air_Temperature_High_Reset_Setpoint',
  ],
  'brick:Temperature_Low_Reset_Setpoint': [
    'brick:Entering_Hot_Water_Temperature_Low_Reset_Setpoint',
    'brick:Leaving_Hot_Water_Temperature_Low_Reset_Setpoint',
    'brick:Outside_Air_Temperature_Low_Reset_Setpoint',
    'brick:Return_Air_Temperature_Low_Reset_Setpoint',
  ],
  'brick:Temperature_Parameter': [
    'brick:High_Temperature_Alarm_Parameter',
    'brick:Lockout_Temperature_Differential_Parameter',
    'brick:Low_Freeze_Protect_Temperature_Parameter',
    'brick:Low_Temperature_Alarm_Parameter',
    'brick:Temperature_Tolerance_Parameter',
  ],
  'brick:Temperature_Sensor': [
    'brick:Air_Temperature_Sensor',
    'brick:Heat_Sink_Temperature_Sensor',
    'brick:Natural_Gas_Temperature_Sensor',
    'brick:Radiant_Panel_Temperature_Sensor',
    'brick:Soil_Temperature_Sensor',
    'brick:Water_Temperature_Sensor',
  ],
  'brick:Temperature_Setpoint': [
    'brick:Air_Temperature_Setpoint',
    'brick:Cooling_Temperature_Setpoint',
    'brick:Heating_Temperature_Setpoint',
    'brick:Radiant_Panel_Temperature_Setpoint',
    'brick:Schedule_Temperature_Setpoint',
    'brick:Water_Temperature_Setpoint',
  ],
  'brick:Temperature_Step_Parameter': ['brick:Air_Temperature_Step_Parameter'],
  'brick:Thermal_Power_Sensor': ['brick:Heating_Thermal_Power_Sensor'],
  'brick:Torque_Sensor': ['brick:Motor_Torque_Sensor'],
  'brick:Unoccupied_Air_Temperature_Setpoint': [
    'brick:Unoccupied_Air_Temperature_Cooling_Setpoint',
    'brick:Unoccupied_Air_Temperature_Heating_Setpoint',
  ],
  'brick:Usage_Sensor': ['brick:Natural_Gas_Usage_Sensor', 'brick:Steam_Usage_Sensor', 'brick:Water_Usage_Sensor'],
  'brick:Valve': [
    'brick:Check_Valve',
    'brick:Gas_Valve',
    'brick:Mixing_Valve',
    'brick:Natural_Gas_Seismic_Shutoff_Valve',
    'brick:Pressure_Reducing_Valve',
    'brick:Pressure_Regulator_Valve',
    'brick:Pressure_Relief_Valve',
    'brick:Refrigerant_Valve',
    'brick:Water_Valve',
  ],
  'brick:Velocity_Pressure_Sensor': ['brick:Air_Velocity_Pressure_Sensor'],
  'brick:Video_Surveillance_Equipment': ['brick:Network_Video_Recorder'],
  'brick:Voltage_Sensor': [
    'brick:Battery_Voltage_Sensor',
    'brick:DC_Bus_Voltage_Sensor',
    'brick:Output_Voltage_Sensor',
  ],
  'brick:Water_Differential_Pressure_Sensor': [
    'brick:Chilled_Water_Differential_Pressure_Sensor',
    'brick:Hot_Water_Differential_Pressure_Sensor',
  ],
  'brick:Water_Differential_Pressure_Setpoint': [
    'brick:Chilled_Water_Differential_Pressure_Setpoint',
    'brick:Hot_Water_Differential_Pressure_Setpoint',
  ],
  'brick:Water_Differential_Temperature_Sensor': [
    'brick:Differential_Discharge_Return_Water_Temperature_Sensor',
    'brick:Differential_Supply_Return_Water_Temperature_Sensor',
    'brick:Hot_Water_Differential_Temperature_Sensor',
  ],
  'brick:Water_Flow_Sensor': [
    'brick:Bypass_Water_Flow_Sensor',
    'brick:Chilled_Water_Flow_Sensor',
    'brick:Condenser_Water_Flow_Sensor',
    'brick:Discharge_Water_Flow_Sensor',
    'brick:Entering_Water_Flow_Sensor',
    'brick:Hot_Water_Flow_Sensor',
    'brick:Leaving_Water_Flow_Sensor',
    'brick:Return_Water_Flow_Sensor',
    'brick:Supply_Water_Flow_Sensor',
  ],
  'brick:Water_Flow_Setpoint': [
    'brick:Bypass_Water_Flow_Setpoint',
    'brick:Chilled_Water_Flow_Setpoint',
    'brick:Condenser_Water_Flow_Setpoint',
    'brick:Discharge_Water_Flow_Setpoint',
    'brick:Entering_Water_Flow_Setpoint',
    'brick:Hot_Water_Flow_Setpoint',
    'brick:Leaving_Water_Flow_Setpoint',
    'brick:Supply_Water_Flow_Setpoint',
  ],
  'brick:Water_Level_Sensor': [
    'brick:Collection_Basin_Water_Level_Sensor',
    'brick:Deionised_Water_Level_Sensor',
  ],
  'brick:Water_Pressure_Sensor': ['brick:Entering_Water_Pressure_Sensor', 'brick:Leaving_Water_Pressure_Sensor'],
  'brick:Water_Pump': ['brick:Chilled_Water_Pump', 'brick:Condenser_Water_Pump', 'brick:Hot_Water_Pump'],
  'brick:Water_Temperature_Alarm': ['brick:Entering_Water_Temperature_Alarm', 'brick:Leaving_Water_Temperature_Alarm'],
  'brick:Water_Temperature_Sensor': [
    'brick:Chilled_Water_Temperature_Sensor',
    'brick:Collection_Basin_Water_Temperature_Sensor',
    'brick:Condenser_Water_Temperature_Sensor',
    'brick:Discharge_Water_Temperature_Sensor',
    'brick:Domestic_Hot_Water_Temperature_Sensor',
    'brick:Entering_Hot_Water_Temperature_Sensor',
    'brick:Entering_Water_Temperature_Sensor',
    'brick:Heat_Exchanger_Discharge_Water_Temperature_Sensor',
    'brick:Heat_Exchanger_Supply_Water_Temperature_Sensor',
    'brick:Leaving_Hot_Water_Temperature_Sensor',
    'brick:Leaving_Water_Temperature_Sensor',
    'brick:Return_Water_Temperature_Sensor',
    'brick:Supply_Water_Temperature_Sensor',
    'brick:Water_Differential_Temperature_Sensor',
  ],
  'brick:Water_Temperature_Setpoint': [
    'brick:Chilled_Water_Temperature_Setpoint',
    'brick:Entering_Water_Temperature_Setpoint',
    'brick:Hot_Water_Temperature_Setpoint',
    'brick:Leaving_Water_Temperature_Setpoint',
    'brick:Max_Water_Temperature_Setpoint',
    'brick:Min_Water_Temperature_Setpoint',
    'brick:Return_Water_Temperature_Setpoint',
  ],
  'brick:Water_Usage_Sensor': ['brick:Hot_Water_Usage_Sensor'],
  'brick:Zone_Air_Temperature_Sensor': [
    'brick:Average_Zone_Air_Temperature_Sensor',
    'brick:Coldest_Zone_Air_Temperature_Sensor',
    'brick:Warmest_Zone_Air_Temperature_Sensor',
  ],
  'brick:Zone_Air_Temperature_Setpoint': [
    'brick:Effective_Zone_Air_Temperature_Setpoint',
    'brick:Occupied_Zone_Air_Temperaure_Setpoint',
    'brick:Unoccupied_Zone_Air_Temperature_Setpoint',
    'brick:Zone_Air_Cooling_Temperature_Setpoint',
    'brick:Zone_Air_Heating_Temperature_Setpoint',
  ],
};

/**
 * Get all subclasses of a BRICK class (recursive)
 *
 * @param {string} brickClass - The BRICK class URI (e.g., "brick:Humidity_Sensor")
 * @param {boolean} includeParent - Whether to include the parent class itself (default: true)
 * @returns {string[]} - Array of all subclass URIs including recursive descendants
 *
 * @example
 * // Get all humidity sensor types including the parent
 * getSubclasses('brick:Humidity_Sensor', true)
 * // Returns: ['brick:Humidity_Sensor', 'brick:Absolute_Humidity_Sensor', 'brick:Relative_Humidity_Sensor',
 * //          'brick:Exhaust_Air_Humidity_Sensor', 'brick:Mixed_Air_Humidity_Sensor', ...]
 *
 * @example
 * // Get only descendant classes
 * getSubclasses('brick:Humidity_Sensor', false)
 * // Returns: ['brick:Absolute_Humidity_Sensor', 'brick:Relative_Humidity_Sensor', ...]
 */
export function getSubclasses(brickClass, includeParent = true) {
  const result = new Set();

  // Normalize the class URI (ensure brick: prefix)
  const normalizedClass = normalizeBrickClass(brickClass);

  if (includeParent && normalizedClass) {
    result.add(normalizedClass);
  }

  // Recursive function to get all descendants
  function collectDescendants(parentClass) {
    const children = BRICK_HIERARCHY[parentClass];
    if (children && Array.isArray(children)) {
      for (const child of children) {
        result.add(child);
        collectDescendants(child); // Recursively get grandchildren
      }
    }
  }

  if (normalizedClass) {
    collectDescendants(normalizedClass);
  }

  return Array.from(result);
}

/**
 * Normalize a BRICK class URI to ensure it has the brick: prefix
 *
 * @param {string} brickClass - The BRICK class (with or without prefix)
 * @returns {string|null} - Normalized URI or null if invalid
 */
export function normalizeBrickClass(brickClass) {
  if (!brickClass || typeof brickClass !== 'string') {
    return null;
  }

  const trimmed = brickClass.trim();

  // Already has prefix
  if (trimmed.startsWith('brick:')) {
    return trimmed;
  }

  // Has full URI
  if (trimmed.includes('brickschema.org')) {
    const parts = trimmed.split('#');
    if (parts.length === 2) {
      return `brick:${parts[1]}`;
    }
    const slashParts = trimmed.split('/');
    return `brick:${slashParts[slashParts.length - 1]}`;
  }

  // Just the class name
  return `brick:${trimmed}`;
}

/**
 * Check if a BRICK class is a subclass of another (or equal to it)
 *
 * @param {string} childClass - The potential child/subclass
 * @param {string} parentClass - The potential parent/ancestor class
 * @returns {boolean} - True if childClass equals parentClass or is a descendant
 *
 * @example
 * isSubclassOf('brick:Outside_Air_Humidity_Sensor', 'brick:Humidity_Sensor')
 * // Returns: true (Outside_Air_Humidity_Sensor is a grandchild of Humidity_Sensor)
 */
export function isSubclassOf(childClass, parentClass) {
  const normalizedChild = normalizeBrickClass(childClass);
  const normalizedParent = normalizeBrickClass(parentClass);

  if (!normalizedChild || !normalizedParent) {
    return false;
  }

  // Same class counts as "subclass of"
  if (normalizedChild === normalizedParent) {
    return true;
  }

  // Check if child is in the descendants of parent
  const descendants = getSubclasses(normalizedParent, false);
  return descendants.includes(normalizedChild);
}

/**
 * Filter a list of BRICK classes to only those that are valid subclasses
 * of a given parent class (or equal to it)
 *
 * @param {string[]} classes - Array of BRICK class URIs to filter
 * @param {string} constraintClass - The parent class that constrains valid options
 * @returns {string[]} - Filtered array containing only valid subclasses
 *
 * @example
 * const allSensors = ['brick:Temperature_Sensor', 'brick:Humidity_Sensor', 'brick:Outside_Air_Humidity_Sensor'];
 * filterByConstraint(allSensors, 'brick:Humidity_Sensor')
 * // Returns: ['brick:Humidity_Sensor', 'brick:Outside_Air_Humidity_Sensor']
 */
export function filterByConstraint(classes, constraintClass) {
  if (!constraintClass) {
    return classes; // No constraint, return all
  }

  const validClasses = getSubclasses(constraintClass, true);
  const validSet = new Set(validClasses);

  return classes.filter((cls) => {
    const normalized = normalizeBrickClass(cls);
    return normalized && validSet.has(normalized);
  });
}

/**
 * Get a user-friendly display name from a BRICK class URI
 *
 * @param {string} brickClass - The BRICK class URI
 * @returns {string} - Human-readable name
 *
 * @example
 * getDisplayName('brick:Outside_Air_Humidity_Sensor')
 * // Returns: 'Outside Air Humidity Sensor'
 */
export function getDisplayName(brickClass) {
  if (!brickClass) {return '';}

  const normalized = normalizeBrickClass(brickClass);
  if (!normalized) {return brickClass;}

  // Remove prefix and convert underscores to spaces
  const name = normalized.replace('brick:', '').replace(/_/g, ' ');
  return name;
}
